import Additives from './Additives';
import Allergens from './Allergens';
import Coupons from './Coupons';
import Calendar from './Calendar';

export default {
  Additives,
  Allergens,
  Coupons,
  Calendar,
};
